<template>
  <div class="product-page" ref="product-page">
    <div id="overview">
      <blade-canvas
        ref="hypernova-blade"
        class="hypernova-blade"
        :theme="'theme-dark'"
      >
        <div class="canvas-txt canvas-blade main-header">
          <h1 class="text-center">Simply Astonishing</h1>
        </div>
        <div class="row canvas-headers canvas-blade">
          <div class="col-5 offset-1 canvas-txt hdr-top">
            <div class="container-txt">
              <h2>Immersive sound, tuned to your ears.</h2>
            </div>
          </div>
        </div>
        <div class="row canvas-headers canvas-blade">
          <div class="col-5 offset-1 canvas-txt hdr-top">
            <div class="container-txt">
              <h2>
                Personalized noise cancellation that even minimizes voices.
              </h2>
            </div>
          </div>
        </div>
        <div class="row canvas-headers canvas-blade">
          <div class="col-5 offset-1 canvas-txt hdr-top">
            <div class="container-txt">
              <h2>
                Awareness with adaptive noise cancellation, just when you need
                it.
              </h2>
            </div>
          </div>
        </div>
        <div class="row canvas-headers canvas-blade">
          <div class="col-5 offset-1 canvas-txt hdr-top">
            <div class="container-txt">
              <h2>
                A new approach to fit that ensures long-term comfort and
                stability.
              </h2>
            </div>
          </div>
        </div>
        <div class="canvas-txt canvas-blade product-name">
          <svg
            width="1379px"
            height="105px"
            viewBox="0 0 1379 105"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="Page-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <path
                d="M91.208,104.904 L104.144,90.516 L94.112,81.936 C99.656,73.884 102.824,64.248 102.824,53.952 L102.824,53.688 C102.824,26.364 81.572,4.32 52.004,4.32 C22.436,4.32 0.92,26.76 0.92,53.952 L0.92,54.216 C0.92,81.54 22.172,103.584 51.74,103.584 C62.564,103.584 72.332,100.416 80.384,95.136 L91.208,104.904 Z M52.004,84.972 C34.58,84.972 22.172,70.848 22.172,53.952 L22.172,53.688 C22.172,36.792 34.316,22.932 51.74,22.932 C69.164,22.932 81.572,37.056 81.572,53.952 L81.572,54.216 C81.572,59.364 80.516,64.248 78.536,68.472 L62.564,53.952 L49.628,68.472 L65.468,82.068 C61.508,83.916 57.02,84.972 52.004,84.972 Z M145.328,103.452 C156.02,103.452 162.356,97.776 167.108,91.44 L167.108,102 L187.172,102 L187.172,28.608 L167.108,28.608 L167.108,69.66 C167.108,79.824 161.696,85.236 153.38,85.236 C145.064,85.236 140.18,79.824 140.18,69.66 L140.18,28.608 L120.248,28.608 L120.248,75.996 C120.248,92.892 129.488,103.452 145.328,103.452 Z M228.752,19.896 L228.752,1.944 L207.632,1.944 L207.632,19.896 L228.752,19.896 Z M228.224,102 L228.224,28.608 L208.292,28.608 L208.292,102 L228.224,102 Z M283.928,103.584 C297.26,103.584 307.028,98.436 313.892,89.988 L302.408,79.824 C296.6,85.236 291.452,87.48 284.192,87.48 C274.556,87.48 267.692,82.332 265.712,72.3 L317.324,72.3 C317.456,70.452 317.588,68.604 317.588,67.02 C317.588,46.164 306.236,27.288 281.948,27.288 C260.696,27.288 245.78,44.448 245.78,65.436 L245.78,65.7 C245.78,88.14 262.016,103.584 283.928,103.584 Z M298.052,59.76 L265.448,59.76 C267.032,49.86 272.972,43.392 281.948,43.392 C291.188,43.392 296.732,50.124 298.052,59.76 Z M359.168,103.188 C366.032,103.188 370.916,101.604 375.272,99.096 L375.272,82.992 C372.236,84.576 368.804,85.5 364.976,85.5 C360.092,85.5 357.848,83.124 357.848,77.976 L357.848,45.768 L375.536,45.768 L375.536,28.608 L357.848,28.608 L357.848,9.6 L337.784,9.6 L337.784,28.608 L328.94,28.608 L328.94,45.768 L337.784,45.768 L337.784,81.276 C337.784,98.172 346.496,103.188 359.168,103.188 Z M439.424,103.584 C457.904,103.584 468.86,96.984 478.76,86.556 L465.824,73.488 C458.168,80.484 451.304,84.972 440.084,84.972 C423.188,84.972 411.44,70.848 411.44,53.952 L411.44,53.688 C411.44,36.792 423.452,22.932 440.084,22.932 C449.984,22.932 457.64,27.156 465.164,34.02 L478.1,19.104 C469.124,10.26 458.3,4.32 440.216,4.32 C410.78,4.32 390.188,26.628 390.188,53.952 L390.188,54.216 C390.188,81.804 411.176,103.584 439.424,103.584 Z M530.504,103.584 C553.34,103.584 570.236,86.556 570.236,65.436 L570.236,65.172 C570.236,44.184 553.472,27.288 530.9,27.288 C508.064,27.288 491.168,44.448 491.168,65.436 L491.168,65.7 C491.168,86.82 507.932,103.584 530.504,103.584 Z M530.9,86.424 C519.02,86.424 510.968,76.656 510.968,65.436 L510.968,65.172 C510.968,53.952 518.36,44.58 530.504,44.58 C542.384,44.58 550.436,54.216 550.436,65.436 L550.436,65.7 C550.436,76.92 543.044,86.424 530.9,86.424 Z M606.8,102 L606.8,60.948 C606.8,50.916 611.948,45.372 620,45.372 C628.052,45.372 632.672,50.784 632.672,60.948 L632.672,102 L652.736,102 L652.736,60.948 C652.736,50.784 657.884,45.372 665.936,45.372 C674.12,45.372 678.608,50.784 678.608,60.948 L678.608,102 L698.672,102 L698.672,54.48 C698.672,36.66 689.3,27.288 673.724,27.288 C663.56,27.288 655.772,31.512 649.436,39.168 C645.608,31.644 638.348,27.288 628.58,27.288 C617.888,27.288 611.552,32.964 606.8,39.168 L606.8,28.608 L586.736,28.608 L586.736,102 L606.8,102 Z M741.836,102 L741.836,45.768 L758.996,45.768 L758.996,29.4 L741.572,29.4 L741.572,26.232 C741.572,20.424 744.476,17.784 749.492,17.784 C753.188,17.784 755.96,18.444 759.128,19.5 L759.128,2.868 C755.3,1.68 750.944,0.888 744.476,0.888 C737.216,0.888 731.54,2.736 727.712,6.564 C723.884,10.524 721.904,16.332 721.904,24.516 L721.904,29.268 L713.06,29.268 L713.06,45.768 L721.904,45.768 L721.904,102 L741.836,102 Z M807.308,103.584 C830.144,103.584 847.04,86.556 847.04,65.436 L847.04,65.172 C847.04,44.184 830.276,27.288 807.704,27.288 C784.868,27.288 767.972,44.448 767.972,65.436 L767.972,65.7 C767.972,86.82 784.736,103.584 807.308,103.584 Z M807.704,86.424 C795.824,86.424 787.772,76.656 787.772,65.436 L787.772,65.172 C787.772,53.952 795.164,44.58 807.308,44.58 C819.188,44.58 827.24,54.216 827.24,65.436 L827.24,65.7 C827.24,76.92 819.848,86.424 807.704,86.424 Z M883.604,102 L883.604,74.676 C883.604,56.856 892.448,48.276 906.44,48.276 L907.496,48.276 L907.496,27.288 C895.088,26.76 887.96,33.492 883.604,43.788 L883.604,28.608 L863.54,28.608 L863.54,102 L883.604,102 Z M946.7,103.188 C953.564,103.188 958.448,101.604 962.804,99.096 L962.804,82.992 C959.768,84.576 956.336,85.5 952.508,85.5 C947.624,85.5 945.38,83.124 945.38,77.976 L945.38,45.768 L963.068,45.768 L963.068,28.608 L945.38,28.608 L945.38,9.6 L925.316,9.6 L925.316,28.608 L916.472,28.608 L916.472,45.768 L925.316,45.768 L925.316,81.276 C925.316,98.172 934.028,103.188 946.7,103.188 Z M1044.512,102 L1044.512,72.696 L1061.276,72.696 C1082.66,72.696 1099.952,61.344 1099.952,39.168 L1099.952,38.904 C1099.952,19.368 1086.092,5.904 1063.256,5.904 L1024.316,5.904 L1024.316,102 L1044.512,102 Z M1061.936,54.612 L1044.512,54.612 L1044.512,24.252 L1061.54,24.252 C1072.496,24.252 1079.492,29.532 1079.492,39.3 L1079.492,39.564 C1079.492,48.144 1072.892,54.612 1061.936,54.612 Z M1209.38,27.288 C1211.87112,27.288 1214.2915,27.4937944 1216.62641,27.8881718 L1378.92,27.888 L1378.92,102.888 L1216.82775,102.889275 C1214.30857,103.345267 1211.68793,103.584 1208.984,103.584 C1186.412,103.584 1169.648,86.82 1169.648,65.7 L1169.648,65.7 L1169.648,65.436 C1169.648,44.448 1186.544,27.288 1209.38,27.288 Z M1134.932,43.788 C1139.288,33.492 1146.416,26.76 1158.824,27.288 L1158.824,27.288 L1158.824,48.276 L1157.768,48.276 C1143.776,48.276 1134.932,56.856 1134.932,74.676 L1134.932,74.676 L1134.932,102 L1114.868,102 L1114.868,28.608 L1134.932,28.608 Z M1208.984,44.58 C1196.84,44.58 1189.448,53.952 1189.448,65.172 L1189.448,65.172 L1189.448,65.436 C1189.448,76.656 1197.5,86.424 1209.38,86.424 C1221.524,86.424 1228.916,76.92 1228.916,65.7 L1228.916,65.7 L1228.916,65.436 C1228.916,54.216 1220.864,44.58 1208.984,44.58 Z"
                id="QuietComfortPro"
                fill="#FFFFFF"
                fill-rule="nonzero"
              ></path>
            </g>
          </svg>
        </div>
      </blade-canvas>
      <blade-canvas ref="every-ear" class="blade-ear" :theme="'theme-light'">
        <template slot="full-width-container">
          <div class="ear-container">
            <blade-ear
              fluid
              v-for="(image, i) in everyEar.images"
              :src="image.src"
              :full="image.full"
              :video="image.video"
              :scale="image.scale"
              :up-close="image.upClose"
              :length="everyEar.images.length"
              :id="i"
              :key="`every-ear-img-${i}`"
            ></blade-ear>
          </div>
        </template>
        <div class="row canvas-headers canvas-blade">
          <div class="offset-7 col-5 canvas-txt">
            <h2>
              <span>Tuned</span>
              <span>To</span>
              <span>Your</span>
              <span>Ears</span>
            </h2>
          </div>
        </div>
        <div class="row canvas-copy canvas-blade section-ear-copy">
          <div class="offset-7 col-5 canvas-txt">
            <p>
              The acoustics of your ear are measured everytime you wear
              QuietComfort Pro, since the fit is always a bit different.
            </p>
          </div>
        </div>
        <div class="row canvas-copy canvas-blade section-acoustics-copy">
          <div class="offset-7 col-5 canvas-txt">
            <p>
              Those measurements are then used to optimize both the noise
              cancelling algorithm and audio equalization for each earbud.
            </p>
          </div>
        </div>
        <div class="row canvas-copy canvas-blade section-acoustics-copy">
          <div class="offset-7 col-5 canvas-txt">
            <p>
              Adjusting 54,000 times per second, our revolutionary noise
              cancelling algorithm can make chatty co-workers and even unhappy
              babies, quieter.
            </p>
          </div>
        </div>
        <div class="row canvas-copy canvas-blade section-acoustics-copy">
          <div class="offset-7 col-5 canvas-txt">
            <p>
              Giving you complete control over how much &mdash; or how little
              &mdash; you hear of your environment.
            </p>
          </div>
        </div>
        <div class="row canvas-copy canvas-blade section-acoustics-copy">
          <div class="offset-7 col-5 canvas-txt">
            <p>
              Aware+ technology lets you hear the world naturally, like there's
              nothing in your ears. And when that loud bus drives by or a car
              honks it's horn, Aware+ seamlessly activates our advanced noise
              cancelling, helping ease you through your day.
            </p>
          </div>
        </div>
        <div
          class="row canvas-copy canvas-blade section-autoaware-copy txt-white"
        >
          <div class="offset-7 col-5 canvas-txt">
            <p>
              When you start speaking or someone says your name, our TalkNow
              feature automatically pauses your music and makes sure noise
              cancelling has been ramped down. So you can talk naturally,
              without having to remove an earbud.
            </p>
          </div>
        </div>
        <div
          class="row canvas-copy canvas-blade section-calling-copy txt-white"
        >
          <div class="offset-7 col-5 canvas-txt">
            <p>
              Our advanced beam-forming microphone array focuses on your voice
              while simultaneously rejecting any noise around so you always
              sound crystal clear on calls.
            </p>
          </div>
        </div>
      </blade-canvas>
      <blade-canvas
        ref="every-moment"
        class="blade-moment"
        :theme="'theme-dark'"
        fluid
      >
        <div class="moment-container">
          <blade-activity :moments="moments"></blade-activity>
        </div>
      </blade-canvas>

      <!--      <blade-video
        @setupVideo="setupVideo"
        id="2"
        ref="vidTwo"
        :fluid="true"
        :video-url="'Raven_Red_Blue.23.webm'"
        bgColor="#252326"
      >
      </blade-video>-->
      <blade-canvas
        ref="hypernova-blow-out"
        class="blade-hypernova-blow-out"
        :theme="'theme-dark'"
      >
        <div class="row canvas-headers canvas-blade">
          <div class="col-4 canvas-txt hdr-top">
            <div class="container-txt">
              <p>
                Our revolutionary StayHear Duo system combines separate eartips
                and stability bands for best fit and performance.
              </p>
            </div>
          </div>
        </div>
        <div class="row canvas-headers canvas-blade">
          <div class="col-4 canvas-txt hdr-top">
            <div class="container-txt">
              <p>
                The custom-designed drivers in QuietComfort Pro deliver powerful
                bass and crisp highs.
              </p>
            </div>
          </div>
        </div>
        <div class="row canvas-headers canvas-blade">
          <div class="col-4 canvas-txt hdr-top">
            <div class="container-txt">
              <p>
                Our advanced signal processing delivers balanced sound at all
                25&nbsp;listening levels whether you're into EDM, Country or Hip
                Hop.
              </p>
            </div>
          </div>
        </div>
        <div class="row canvas-blade blade-stats">
          <div class="col-4 offset-1 canvas-txt hdr-center">
            <div class="container-txt">
              <ul class="product-stats">
                <li>
                  <h2>24<span> hrs</span></h2>
                  <p>
                    of total listening time.<br />
                    with multiple charges in<br />
                    the USB-C charge case.
                  </p>
                </li>
                <li>
                  <h2>6<span> hrs</span></h2>
                  <p>
                    of listening time on<br />
                    a single charge.
                  </p>
                </li>
                <li>
                  <h2>2<span> hrs</span></h2>
                  <p>
                    of listening time with<br />
                    a 15 minute charge.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row canvas-headers canvas-blade canvas-blade-final">
          <div class="col-4 canvas-txt hdr-top">
            <div class="container-txt">
              <p>
                Plus, the Bose Music app makes it easy to connect, update and
                further personalize your QuietComfort Pro.
              </p>
            </div>
          </div>
          <div class="offset-2 col-6 phone-and-buds">
            <img :src="require(`@/assets/phone-and-buds.png`)" />
          </div>
        </div>
      </blade-canvas>
    </div>
    <blade-faq
      :product="product"
      id="tech-spec"
      mainProductImage="tech-specs-main-product-image.png"
    />
  </div>
</template>

<script>
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);
import { mapActions } from "vuex";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import BladeFaq from "@/components/blade-faq";
import BladeCanvas from "@/components/blade-canvas";
import BladeActivity from "@/components/blade-activity";
import BladeEar from "@/components/blade-ear";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "quiet-comfort-earbud",
  components: { BladeActivity, BladeCanvas, BladeFaq, BladeEar },
  data() {
    return {
      timelines: [],
    };
  },
  computed: {
    product() {
      return this.$store.state.product.FAQ;
    },
    theme() {
      return this.$store.state.theme;
    },
    everyEar() {
      return this.$store.state.product.everyEar;
    },
    moments() {
      return this.$store.state.product.moments;
    },
  },
  methods: {
    ...mapActions(["setTheme"]),
    bladeSwitchTheme() {
      const sections = Array.from(
        this.$refs["product-page"].querySelectorAll(".blade-switch-theme")
      );

      sections.forEach((section) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top-=40 top",
          scrub: true,
          onToggle: () =>
            this.setTheme(
              section.classList.contains("theme-dark") ? "dark" : "light"
            ),
          onEnterBack: () =>
            this.setTheme(
              section.classList.contains("theme-dark") ? "dark" : "light"
            ),
        });
      });
    },
    setupMasterTimeLine() {
      const wrapper = this.$refs["product-page"].querySelector("#overview");
      const bladeContainers = Array.from(
        this.$refs["product-page"].querySelectorAll(".blade-canvas")
      );
      const masterTl = gsap.timeline({
        defaults: {
          duration: 5,
          ease: "expo.in",
        },
        scrollTrigger: {
          trigger: wrapper,
          scrub: true,
          start: "center center",
          pin: true,
          end: "30000vh",
        },
      });
      gsap.set(wrapper, { zIndex: 500, position: "relative" });
      bladeContainers.forEach((blade, i) => {
        const lastBlade = i === bladeContainers.length - 1;
        if (i > 0 && !lastBlade) {
          gsap.set(blade, { x: "100vw" });
        }
        if (lastBlade) {
          gsap.set(blade, { y: "100vh" });
        }
      });
      this.hyperNovaCopy(masterTl);
      masterTl.fromTo(
        this.$refs["every-ear"].$el,
        { scale: 0.15, autoAlpha: 0 },
        { x: 0, scale: 1, autoAlpha: 1, duration: 5, ease: "expo.in" },
        "-=5.75"
      );
      this.setupEveryEar(masterTl);
      gsap.set(this.$refs["every-moment"].$el, { x: 0, zIndex: 3 });
      masterTl.fromTo(
        this.$refs["every-moment"].$el,
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 5 }
      );
      masterTl.to(this.$refs["every-ear"].$el, { autoAlpha: 0, duration: 0 });
      this.setupMoment(masterTl);
      masterTl.to(this.$refs["every-moment"].$el, {
        autoAlpha: 0,
        duration: 3,
      });
      masterTl.to(
        this.$refs["hypernova-blow-out"].$el,
        { y: 0, duration: 0 },
        "-=3"
      );
      this.setupEveryEarBlowout(masterTl);
      this.hyperNovaBlowOutVideo();
    },
    setupVideo(args) {
      const videoTl = gsap.timeline({
        paused: true,
        scrollTrigger: {
          pin: args.container,
          trigger: args.container,
          start: "center center",
          end: "+=700%",
          scrub: true,
          onUpdate: (self) => {
            let videoTL = gsap.utils.interpolate(0, args.video.duration);
            args.video.currentTime = videoTL(self.progress);
          },
        },
      });
      this.timelines.push(videoTl);
    },
    hyperNovaCopy(tl) {
      const wrapper = this.$refs["hypernova-blade"].$el;
      const blades = Array.from(wrapper.querySelectorAll(".canvas-blade"));
      const product = wrapper.querySelectorAll(".product-name");
      /*let tl = gsap.timeline({
        defaults: { duration: 5 },
        scrollTrigger: {
          trigger: wrapper,
          markers: true,
          scrub: true,
          start: "center center",
          end: "7395px",
          pin: true
        }
      });*/

      blades.forEach((blade, i) => {
        if (blade.classList.contains("main-header")) {
          tl.to(blade, { scale: 2.5, autoAlpha: 0, duration: 5 }, 13);
        } else {
          if (blade.classList.contains("product-name")) {
            tl.fromTo(
              product,
              { autoAlpha: 0 },
              { autoAlpha: 1, duration: 3 }
            ).fromTo(
              product,
              { x: "100vw", y: 0 },
              {
                x: "-12488px",
                y: "-30vh",
                duration: 30,
                scale: 20,
                ease: "expo.in",
              },
              "-=3"
            );
          } else {
            tl.fromTo(
              blade,
              { y: 0, autoAlpha: 0 },
              { y: -25, autoAlpha: 1, duration: 5 },
              i === 0 ? "-=40" : "+=5"
            ).to(
              blade,
              { autoAlpha: 0, duration: 3 },
              i !== 1 || i === 2 ? null : "+=3"
            );
          }
        }
      });
    },
    hyperNovaVideo() {
      const wrapper = this.$refs["hypernova-blade"].$el;
      const canvas = wrapper.querySelector("canvas");
      const context = canvas.getContext("2d");

      canvas.width = 650;
      canvas.height = 550;

      const frameCount = 433;
      const currentFrame = (index) =>
        `/img/sequences/hypernova/${(index + 1)
          .toString()
          .padStart(4, "0")}.jpg`;

      const images = [];
      const hypernova = {
        frame: 0,
      };

      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      gsap.to(hypernova, {
        frame: frameCount - 1,
        snap: "frame",
        scrollTrigger: {
          trigger: wrapper,
          start: "center center",
          scrub: 0.5,
          end: "9000vh",
        },
        onUpdate: render,
      });

      images[0].onload = render;

      function render() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(images[hypernova.frame], 0, 0);
      }
    },
    setupEveryEar(tl) {
      const wrapper = this.$refs["every-ear"].$el;
      const earContainer = wrapper.querySelector(".ear-container");
      let ears = Array.from(wrapper.querySelectorAll(".bg-ear"));
      let earBGs = [];
      let earVideo = [];
      let earBGUpClose = [];
      let earScaleOut = [];
      ears.forEach((bg) => {
        if (bg.classList.contains("up-close")) {
          earBGUpClose.push(bg);
        } else if (bg.classList.contains("bg-ear-full-scale")) {
          earScaleOut.push(bg);
          earBGs.push(bg);
        } else if (bg.classList.contains("ear-video")) {
          earVideo.push(bg);
        } else {
          earBGs.push(bg);
        }
      });
      const lastEarBG = earBGUpClose.pop();
      const bladeHeadline = wrapper.querySelector(".canvas-headers");
      const headlines = Array.from(
        wrapper.querySelectorAll(".canvas-headers h2 span")
      );
      const earMeasurementCopy = wrapper.querySelector(
        ".canvas-copy.section-ear-copy"
      );
      const acousticsCopy = Array.from(
        wrapper.querySelectorAll(".canvas-copy.section-acoustics-copy")
      );
      const autoAwareCopy = wrapper.querySelector(
        ".canvas-copy.section-autoaware-copy"
      );
      const callingCopy = wrapper.querySelector(
        ".canvas-copy.section-calling-copy"
      );

      /*let tl = gsap.timeline({
        defaults: { duration: 1 },
        scrollTrigger: {
          trigger: wrapper,
          markers: true,
          scrub: true,
          start: "top top", //Element Canvas
          end: "500%",
          pin: true
        }
      });*/

      tl.from(headlines, {
        y: 55,
        opacity: 0,
        duration: 5,
        stagger: 3,
        ease: "expo.out",
      })
        .to(
          earBGUpClose,
          {
            y: "-100vh",
            backgroundPosition: `calc(50% - 348px) ${innerHeight}px`,
            duration: 5,
            stagger: 3,
          },
          "-=12"
        )
        .to(bladeHeadline, { y: -100, autoAlpha: 0 })
        .fromTo(
          earMeasurementCopy,
          { y: 55, opacity: 0 },
          { y: 0, opacity: 1, duration: 2 }
        )
        .to(lastEarBG, { autoAlpha: 0 }, "-=1")
        .to(earMeasurementCopy, { y: -55, opacity: 0 }, "+=3")
        .to(earVideo, { autoAlpha: 0 }, "-=5")
        .to(earScaleOut, {
          transform: "scale(1)",
          backgroundPosition: "calc(50% + 0px ) 50%",
        })
        .to(
          earContainer,
          {
            clipPath: "circle(100vw at calc(50% - 348px) center)",
            ease: "expo.in",
          },
          "-=3"
        )
        .to(
          earBGs[0],
          {
            opacity: 0,
          },
          "-=1"
        );

      acousticsCopy.forEach((copy, i) => {
        tl.fromTo(
          copy,
          { y: 55, opacity: 0 },
          { y: 0, opacity: 1, duration: 2 },
          i === 0 ? "-=2" : null
        ).to(
          copy,
          { y: -55, opacity: 0 },
          i === acousticsCopy.length - 1 ? "+=5" : "+=3"
        );
      });

      tl.to(earBGs[1], {
        opacity: 0,
        duration: 4,
      })
        .fromTo(
          autoAwareCopy,
          { y: 55, opacity: 0 },
          { y: 0, opacity: 1, duration: 2 }
        )
        .to(autoAwareCopy, { y: -55, opacity: 0 }, "+=3")
        .to(earBGs[2], {
          opacity: 0,
          duration: 4,
        })
        .fromTo(
          callingCopy,
          { y: 55, opacity: 0 },
          { y: 0, opacity: 1, duration: 2 }
        )
        .to(callingCopy, { y: -55, opacity: 0 }, "+=3");
    },
    setupMoment(tl) {
      const wrapper = this.$refs["every-moment"].$el;
      const headers = Array.from(wrapper.querySelectorAll(".headers h2"));
      const firstCol = wrapper.querySelector(".images .first-col");
      const lastCol = wrapper.querySelector(".images .last-col");

      const initialOffset = headers.length * -100 + "vh";

      gsap.set(firstCol, { y: "100vh" });
      gsap.set(lastCol, { y: initialOffset });

      /*const tl = gsap.timeline({
        scrollTrigger: {
          defaults: { duration: 5 },
          trigger: wrapper,
          markers: true,
          scrub: true,
          start: "center center", //Element Canvas
          end: "600%",
          pin: true
        }
      });*/

      headers.forEach((header, x) => {
        tl.to(header, { autoAlpha: 1, duration: 2.5 }, "-=3")
          .to(
            lastCol,
            { y: "+=100vh", autoAlpha: 1, duration: 5 },
            x === 0 ? "-=1" : "-=2.5"
          )
          .to(firstCol, { y: "-=100vh", autoAlpha: 1, duration: 5 }, "-=5")
          .to(
            header,
            { autoAlpha: 0, duration: 2.5 },
            x === headers.length - 1 ? "+=10" : "+=3"
          );
      });
      tl.to(lastCol, { y: "+=100vh", autoAlpha: 1, duration: 5 }, "-=7").to(
        firstCol,
        { y: "-=100vh", autoAlpha: 1, duration: 5 },
        "-=7"
      );
    },
    setupEveryEarBlowout(tl) {
      const wrapper = this.$refs["hypernova-blow-out"].$el;
      const blades = Array.from(wrapper.querySelectorAll(".canvas-blade"));
      const canvas = wrapper.querySelector("canvas");
      const phoneAndBuds = wrapper.querySelector(".phone-and-buds");
      const productStats = Array.from(
        wrapper.querySelectorAll(".product-stats li")
      );
      /*let tl = gsap.timeline({
        defaults: { duration: 5 },
        scrollTrigger: {
          trigger: wrapper,
          markers: true,
          scrub: true,
          start: "center center",
          end: "7395px",
          pin: true
        }
      });*/

      blades.forEach((blade, i) => {
        gsap.set(blade, { autoAlpha: 0 });
        if (blade.classList.contains("blade-stats")) {
          tl.fromTo(blade, { y: 0 }, { y: 0, autoAlpha: 1, duration: 0 })
            .fromTo(
              productStats,
              { x: -50, autoAlpha: 0 },
              {
                x: 0,
                autoAlpha: 1,
                stagger: 3.5,
                ease: CustomEase.create(
                  "custom",
                  "M0,0 C0.536,0 0.719,0.981 0.726,0.998 0.788,0.914 0.84,0.936 0.859,0.95 0.878,0.964 0.897,0.985 0.911,0.998 0.922,0.994 0.939,0.984 0.954,0.984 0.969,0.984 1,1 1,1 "
                ),
              }
            )
            .to(blade, { autoAlpha: 0, duration: 10 }, "+=15")
            .to(canvas, { autoAlpha: 0, duration: 10 }, "-=10");
        } else if (blade.classList.contains("canvas-blade-final")) {
          tl.fromTo(blade, { y: 50, autoAlpha: 0 }, { y: -25, autoAlpha: 1 })
            .fromTo(
              phoneAndBuds,
              { scale: 0.95, autoAlpha: 0 },
              { scale: 1, autoAlpha: 1, duration: 10, ease: "expo.out" }
            )
            .to(blade, { y: -25 }, "+=10");
        } else {
          tl.fromTo(
            blade,
            { y: 0, autoAlpha: 0 },
            { y: -25, autoAlpha: 1, duration: 2 },
            i === 0
              ? "+=15.8"
              : i === 1
              ? "+=3.8"
              : i === 2
              ? "+=15.8"
              : i === 3
              ? "+=61"
              : "+=10"
          ).to(blade, { autoAlpha: 0 }, "+=3");
        } // 80 : 60+60+60+90 = 270 / 3.375
      });
    },
    hyperNovaBlowOutVideo() {
      const wrapper = this.$refs["hypernova-blow-out"].$el;
      const canvas = wrapper.querySelector("canvas");
      const context = canvas.getContext("2d");

      canvas.width = 650;
      canvas.height = 550;

      const frameCount = 380;
      const currentFrame = (index) =>
        `/img/sequences/hypernovaEarPieces/${(index + 1)
          .toString()
          .padStart(4, "0")}.jpg`;

      const images = [];
      const hypernova = {
        frame: 0,
      };

      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      gsap.to(hypernova, {
        frame: frameCount - 1,
        snap: "frame",
        scrollTrigger: {
          trigger: wrapper,
          start: "19000vh",
          scrub: 0.5,
          end: "30000vh",
        },
        onUpdate: render,
      });

      images[0].onload = render;

      function render() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(images[hypernova.frame], 0, 0);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setTheme("dark");
      this.setupMasterTimeLine();
      // this.bladeSwitchTheme();
      //this.hyperNovaCopy();
      this.hyperNovaVideo();
      //this.setupEveryEar();
      // this.setupMoment();
      // this.setupEveryEarBlowout();
      // this.hyperNovaBlowOutVideo();
    });
  },
};
</script>

<style scoped lang="scss">
.product-page {
  background: #ffffff;
}
#overview {
  background: #000;
  height: 100vh;
  overflow: hidden;
}
</style>
